<template>

    <div class="block">
      <div class="block-header block-header-default">
        <h3 class="block-title">{{translate[lang]['personalpreferences']}}</h3>
        <div class="block-options">
          <button
            type="button"
            class="btn-block-option"
            data-toggle="block-option"
            data-action="content_toggle"
          >
            <i class="si si-arrow-up"></i>
          </button>
        </div>
      </div>
      <div class="block-content">

        <div class="form-check">
          <input class="form-check-input" type="checkbox" name="preferences[data]" id="preferences[data]">
          <label class="form-check-label" for="preferences[data]" style="font-weight: normal;">
            {{ translate[lang]['preferencesline1'] }}
          </label>
        </div>
        <div class="form-check">
          <input class="form-check-input" type="checkbox" name="preferences[email]" id="preferences[email]">
          <label class="form-check-label" for="preferences[email]" style="font-weight: normal;">
            {{translate[lang]['preferencesline2']}}
          </label>
        </div>
        <div class="form-check">
          <input class="form-check-input" type="checkbox" name="preferences[phone]" id="preferences[phone]">
          <label class="form-check-label" for="preferences[phone]" style="font-weight: normal;">
            {{translate[lang]['preferencesline3']}}
          </label>
        </div>

      </div>
    </div>

</template>

<script>
export default {
  name: "PersonalPreferences",
};
</script>